/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Files_DescInputs */

const en_wc_why_files_desc = /** @type {(inputs: Wc_Why_Files_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens and saves .docx; imports .doc; reads and writes .odt, .rtf, .html, .md, .tex and .txt; exports PDF with selectable text.`)
};

/**
* | output |
* | --- |
* | "Opens and saves .docx; imports .doc; reads and writes .odt, .rtf, .html, .md, .tex and .txt; exports PDF with selectable text." |
*
* @param {Wc_Why_Files_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_files_desc = /** @type {((inputs?: Wc_Why_Files_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Files_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_files_desc(inputs)
});
export { wc_why_files_desc as "wc.why.files.desc" }